export const SIGNIFYD_LIBRARY_URL =
  'https://cdn-scripts.signifyd.com/api/script-tag.js'

export const SIGNIFYD_COOKIE_NAME = 'signifyd_session_id'
export const SIGNIFYD_COOKIE_MAX_AGE = 60 * 60 * 24
